@if (form) {
  <mat-card class="m-2" fxLayout="column" fxLayoutAlign="space-between start">
    <!-- Header -->
    <app-card-header
      icono="description"
      [title]="title"
      [draggable]="true"
    ></app-card-header>

    <mat-card-content style="overflow: auto" class="cardContentDialog">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <!-- Datos del Documento -->
        <app-content-card
          title="Datos del Documento"
          icon="description"
          color="blue"
        >
          <section class="inputs-group">
            <!-- Tipo -->
            <ng-select
              [items]="tipos"
              formControlName="tipo"
              [multiple]="false"
              placeholder="Tipo de Documento"
              style="width: 100%"
              [hideSelected]="true"
              [fixedPlaceholder]="true"
              appendTo="body"
              required
            ></ng-select>

            <!-- Emision y Vencimiento -->
            <div class="form-row">
              <mat-form-field style="width: 100%">
                <mat-icon matPrefix>event</mat-icon>
                <mat-label>Fecha de Emisión</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker1"
                  formControlName="emision"
                />
                <mat-hint>DD/MM/YYYY</mat-hint>
                <button
                  irxBotonIcono
                  tamano="compacto"
                  matIconSuffix
                  tooltip="Elegir fecha"
                  (click)="picker1.open()"
                >
                  <mat-icon>calendar_month</mat-icon>
                </button>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>

              <mat-form-field style="width: 100%">
                <mat-icon matPrefix>event_busy</mat-icon>
                <mat-label>Fecha de Vencimiento</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker2"
                  formControlName="vencimiento"
                />
                <mat-hint>DD/MM/YYYY</mat-hint>
                <button
                  irxBotonIcono
                  tamano="compacto"
                  matIconSuffix
                  tooltip="Elegir fecha"
                  (click)="picker2.open()"
                >
                  <mat-icon>calendar_month</mat-icon>
                </button>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </div>

            <!-- Descripcion -->
            <mat-form-field style="width: 100%">
              <mat-icon matPrefix>notes</mat-icon>
              <mat-label>Descripción</mat-label>
              <textarea
                matInput
                formControlName="descripcion"
                style="min-height: 80px"
              ></textarea>
            </mat-form-field>
          </section>
        </app-content-card>

        <!-- Imágenes -->
        <app-content-card title="Imágenes" icon="photo_library" color="green">
          <section class="inputs-group centered">
            <app-upload-file
              (urlChange)="onUrlChange($event)"
              (loadingFile)="loadingFile($event)"
              textoBoton="Subir Imagen"
            ></app-upload-file>

            @if (loading) {
              <mat-progress-bar
                color="primary"
                mode="indeterminate"
              ></mat-progress-bar>
            }

            @for (
              urlActual of documentoImagenes.value;
              track urlActual;
              let i = $index
            ) {
              <div class="imagen-container">
                <div class="imagen-preview">
                  <img [src]="urlActual" alt="Imagen" />
                </div>
                <div class="imagen-actions">
                  <app-button
                    matType="mat-fab extended"
                    icon="cancel"
                    color="warn"
                    (click)="eliminarImagen(i)"
                    text="Eliminar"
                  ></app-button>
                </div>
              </div>
            }
          </section>
        </app-content-card>
      </form>
    </mat-card-content>

    <mat-divider></mat-divider>

    <!-- Acciones -->
    <mat-card-actions class="actions-create">
      <app-button
        matType="mat-fab extended"
        color="neutral"
        (click)="this.dialog.close()"
        text="Cancelar"
        icon="close"
      ></app-button>
      <app-button
        matType="mat-fab extended"
        [disabled]="!this.form.valid || loading"
        color="primary"
        text="Guardar"
        icon="save"
        type="submit"
        (click)="onSubmit()"
      ></app-button>
    </mat-card-actions>
  </mat-card>
}
